module.exports = __webpack_public_path__ + "img/loading.c3f1510e.gif";